/* ==========================================================================
   product-hero.js — Polène 1:1
   - Gallery thumbnail click → swap the right-column main image
   - Gallery arrow buttons → scroll the thumbnail track
   - SKU click → already handled by <a href> links, but we also update the
     visual highlight + change right column main image to that variant's
     image if available
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    const root = document.querySelector('[data-pdp-hero]');
    if (!root) return;

    /* ---------- Match left media frame height to right column on desktop ---------- */
    function syncHeights() {
      if (window.innerWidth < 1025) return;
      const right = root.querySelector('.pdp-hero__info-col');
      const frame = root.querySelector('.pdp-hero__media-frame');
      if (right && frame) {
        const h = right.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--pdp-right-col-h', h + 'px');
      }
    }
    syncHeights();
    window.addEventListener('resize', syncHeights);
    /* Re-sync after images load (so the right column's final height is correct). */
    window.addEventListener('load', syncHeights);
    const observer = new MutationObserver(syncHeights);
    observer.observe(root, { childList: true, subtree: true, attributes: true });

    /* ---------- GALLERY: click thumbnail → swap main image ---------- */
    const mainImg = root.querySelector('.pdp-hero__product-img');
    const galleryItems = root.querySelectorAll('[data-gallery-idx]');
    const galleryLinks = root.querySelectorAll('.pdp-hero__gallery-link');

    function activateGalleryItem(idx) {
      galleryItems.forEach(function (el) {
        el.classList.toggle('is-active', String(el.dataset.galleryIdx) === String(idx));
      });
    }

    function setMainImageFromLink(link) {
      if (!mainImg || !link) return;
      const src = link.dataset.gallerySrc;
      const srcset = link.dataset.gallerySrcset;
      const width = link.dataset.galleryWidth;
      const height = link.dataset.galleryHeight;
      const aspect = link.dataset.galleryAspect;
      const idx = link.parentElement.dataset.galleryIdx;

      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      if (width) mainImg.width = width;
      if (height) mainImg.height = height;
      if (aspect) mainImg.dataset.aspect = aspect;
      activateGalleryItem(idx);

      const track = root.querySelector('[data-gallery-track]');
      if (track && link.parentElement) {
        const item = link.parentElement;
        const trackRect = track.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        if (itemRect.left < trackRect.left || itemRect.right > trackRect.right) {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    galleryLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        setMainImageFromLink(link);
      });
    });

    /* ---------- GALLERY ARROWS: scroll thumbnail track ---------- */
    const track = root.querySelector('[data-gallery-track]');
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');
    if (track) {
      const step = 80;
      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step * 3, behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left:  step * 3, behavior: 'smooth' }); });
      function updateArrowState() {
        if (!prevBtn || !nextBtn) return;
        const max = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= max;
      }
      if (track) { track.addEventListener('scroll', updateArrowState); window.addEventListener('resize', updateArrowState); setTimeout(updateArrowState, 100); }
    }

    /* ---------- SKU arrow buttons (left/right scroll within SKU track) ---------- */
    const skuTrack = root.querySelector('[data-sku-track]');
    const skuPrev = root.querySelector('[data-sku-prev]');
    const skuNext = root.querySelector('[data-sku-next]');
    if (skuTrack) {
      const step = 80;
      if (skuPrev) skuPrev.addEventListener('click', function () { skuTrack.scrollBy({ left: -step * 3, behavior: 'smooth' }); });
      if (skuNext) skuNext.addEventListener('click', function () { skuTrack.scrollBy({ left:  step * 3, behavior: 'smooth' }); });
    }

    /* ---------- VARIANT SWAP (right side image swaps when SKU clicked) ---------- */
    const skuLinks = root.querySelectorAll('.pdp-hero__sku-link');
    skuLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        /* Let the link navigate to the variant URL (so the URL changes);
           no e.preventDefault() — full page reload is fine for now. */
        const parent = link.closest('.pdp-hero__sku-item');
        if (parent) {
          root.querySelectorAll('.pdp-hero__sku-item').forEach(function (el) { el.classList.remove('is-active'); });
          parent.classList.add('is-active');
        }
      });
    });

    /* ---------- STICKY CTA visibility ---------- */
    const sticky = document.querySelector('.pdp-sticky-cta');
    if (sticky) {
      const atc = root.querySelector('.pdp-hero__atc');
      if (atc) {
        function update() {
          const r = atc.getBoundingClientRect();
          const inView = r.top < window.innerHeight && r.bottom > 0;
          sticky.classList.toggle('is-visible', !inView);
        }
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    }

    /* ---------- ATC form (Variant-aware) ---------- */
    const atcForm = root.querySelector('[data-product-form]');
    if (atcForm) {
      const addBtn = atcForm.querySelector('[data-add-to-cart]');
      const variantInput = atcForm.querySelector('[data-variant-input]');
      atcForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const id = variantInput.value;
        if (!id) return;
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }
        const fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', '1');
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          credentials: 'same-origin'
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (addBtn) { addBtn.textContent = 'Added to cart'; setTimeout(function () { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }, 1200); }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
          });
      });
    }

    /* ---------- TABS (Polène 1:1 inline tab strip) ---------- */
    const tabsRoot = document.querySelector('[data-pdp-tabs]');
    if (tabsRoot) {
      const tabBtns = tabsRoot.querySelectorAll('[data-pdp-tab]');
      const tabPanels = tabsRoot.querySelectorAll('[data-pdp-panel]');
      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const target = btn.dataset.pdpTab;
          tabBtns.forEach(function (b) {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          tabPanels.forEach(function (p) {
            const active = p.dataset.pdpPanel === target;
            p.classList.toggle('is-active', active);
            if (active) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
          });
          /* Re-sync heights after tab switch because panel sizes differ. */
          setTimeout(syncHeights, 50);
        });
      });
    }

    /* ---------- WISHLIST (Polène 1:1 heart icon) ---------- */
    const wishlistBtn = root.querySelector('[data-pdp-wishlist]');
    if (wishlistBtn) {
      const productId = (document.querySelector('[data-section-type="main-product"]') || {}).dataset && document.querySelector('[data-section-type="main-product"]').dataset.productId;
      const key = 'pl_wishlist_' + (productId || 'pdp');
      wishlistBtn.addEventListener('click', function () {
        const isActive = wishlistBtn.classList.toggle('is-active');
        let list = [];
        try { list = JSON.parse(localStorage.getItem('pl_wishlist') || '[]'); } catch (e) {}
        if (isActive) { if (list.indexOf(key) === -1) list.push(key); }
        else { list = list.filter(function (k) { return k !== key; }); }
        try { localStorage.setItem('pl_wishlist', JSON.stringify(list)); } catch (e) {}
      });
      try {
        const list = JSON.parse(localStorage.getItem('pl_wishlist') || '[]');
        if (list.indexOf(key) !== -1) wishlistBtn.classList.add('is-active');
      } catch (e) {}
    }
  });
})();
